import React, { useEffect, useState } from 'react'
import isPayoutOTPNeeded from '../../../controllers/settings/wallet/isPayoutOTPNeeded';
import { enqueueSnackbar } from 'notistack';
import TextInput from '../../form/TextInput';
import { MenuItem } from '@mui/material';
import { Modal3 } from '../../DIsplay/Modal/Modal3';
import OTPInput from '../../Auth/OTPInput';
import Button1 from '../../form/Button1';
import enableWalletPayoutOTP from '../../../controllers/settings/wallet/enableWalletPayoutOTP';
import disableWalletPayoutOTP from '../../../controllers/settings/wallet/disableWalletPayoutOTP';
import finalizeDisableWalletPayoutOTP from '../../../controllers/settings/wallet/finalizeDisableWalletPayoutOTP';

export default function PayoutOTPSetting() {
    const [isOTPNeeded,setIsOTPNeeded] = useState(false);
    const [value,setValue] = useState('enabled')
    const [openOTPModal,setOpenOTPModal] = useState();
    const [loadings,setLoadings] = useState({submit: false})
    
    useEffect(() => {
        checkOTPNeeded()
    },[])

    useEffect(() => {
        setValue(isOTPNeeded ? 'enabled':'disabled')
    },[isOTPNeeded])

    async function checkOTPNeeded() {
        const res = await isPayoutOTPNeeded();
        if(res?.return) {
            setIsOTPNeeded(res?.data?.isOTPNeeded);
        } else enqueueSnackbar(res?.msg,{variant: 'error'})
    }

    async function handleEnable(val) {
        setLoadings({...loadings,enable: true})
        const res = await enableWalletPayoutOTP();
        setLoadings({...loadings,enable: false})
        if(res?.return) {
            setValue(val)
        } else enqueueSnackbar(res.msg,{variant: 'error'})
    }
    async function handleDisable(val) {
        setLoadings({...loadings,disable: true})
        const res = await disableWalletPayoutOTP();
        setLoadings({...loadings,disable: false})
        if(res?.return) {
            setOpenOTPModal({otp: ''})
        } else enqueueSnackbar(res.msg,{variant: 'error'})
    }
    
    async function handleChange(val) {
        if(val === 'enabled')
            return handleEnable();
        else handleDisable(val);
    }

    async function handleSubmitOTP() {
        const res = await finalizeDisableWalletPayoutOTP(openOTPModal?.otp)
        if(res?.return) {
            enqueueSnackbar(res.msg,{variant: 'success'})
            setValue('disabled')
        } else enqueueSnackbar(res.msg,{variant: 'error'})
    }
    
  return (
    <div className='flex flex-col gap-4'>
      <h5>Wallet Payout OTP</h5>
      
      <div className='flex justify-start'>
        <TextInput select label='' className='w-auto bg-secondary'
            value={value}
            onChange={(ev) => handleChange({value: ev.target.value})}
        >
            <MenuItem value='enabled'>Enabled</MenuItem>
            <MenuItem value='disabled'>Disabled</MenuItem>
        </TextInput>
      </div>

      <Modal3 open={openOTPModal} setOpenOTPModal={() => setOpenOTPModal(false)}
        title='Wallet Payout OTP'
      >
        <div className='flex flex-col gap-4'>
            <OTPInput value={openOTPModal?.otp||''} onChange={(otp) => setOpenOTPModal({...openOTPModal,otp})} />
            <div className='flex gap-4 items-center'>
                <div>
                    <Button1 variant='outlined'>Close</Button1>
                </div>
                <Button1 onClick={() => handleSubmitOTP()}>Confirm</Button1>
            </div>
        </div>
      </Modal3>
      
    </div>
  )
}
